<template>
  <div class="switch">
    <div class="d-flex align-items-center mt-2 pb-2 border-bottom">
      <div class="col-8">
        {{ $t("NOTIFICATION_ID_" + item.notificationId) }}
      </div>
      <div class="col-4 text-right">
        <Switcher
          :key="item.notificationId"
          :value="item.enabled ? true : false"
          :text="true"
          :disabled="!item.canBeEdited ? true : false"
          :field-id="'notificationRegister' + item.notificationId"
          @switch="switchNotification"
        />
      </div>
    </div>

    <div v-if="errorsToTranslate.length > 0">
      <error-modal
        :opened="openedError"
        :centered="true"
        :errors="errorsToTranslate"
        @close="openedError = false"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Switcher from "@/components/switcher";
import ErrorModal from "@/components/confirmations/translatedErrors.vue";
export default {
  components: {
    Switcher,
    "error-modal": ErrorModal
  },
  props: {
    item: Object,
    customer: Object,
    fromProfile: Boolean,
    email: String,
    text: Boolean
  },
  data() {
    return {
      errorsToTranslate: [],
      openedError: false
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    switchNotification() {
      this.errorsToTranslate = [];

      console.log("switch", "clicked", this.email);
      console.log("switch", "item", this.item);
      console.log("switch", "fromProfile", this.fromProfile);
      if (this.item.canBeEdited) {
        let endpointUrl = "";
        let email = this.item.email === undefined ? this.email : undefined;

        console.log(this.item, "ITEM77");
        if (!this.fromProfile && email) {
          endpointUrl =
            process.env.VUE_APP_API +
            "/notifications/customers/" +
            this.customer.customerId +
            "/notification/" +
            this.item.notificationId +
            "/emails/" +
            email;
        } else {
          endpointUrl =
            process.env.VUE_APP_API +
            "/notifications/customers/" +
            this.customer.customerId +
            "/notification/" +
            this.item.notificationId;
        }

        axios
          .patch(endpointUrl, {
            enabled: this.item.enabled ? false : true
          })
          .then(() => {
            this.item.enabled = this.item.enabled ? false : true;
          })
          .catch(error => {
            console.log("error found", error);
            this.errorsToTranslate.push(error.data);
            return true;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
